window.ProjectPage = {
    luggage: [],
    contextAux : 0,
    project_id : 0,
    contribution_id : 0,
    choosenDirectReward : null,
    multipleRewards : false,
    multipleRewardsData : null,
    freeReward: false,
    freeRewardValue : 0,
    benfeitoria_contribution: null,
    benfeitoria_contribution_value: null,
    anonColaboration: 0,
    userFreeUpdate : false,
    confirmationPage : null,
    tabContributorsPage : 1,
    recaptchaResponse: null,
    recaptchaData: null,
    submitSelector: '.btn-register-user',
    hasValidEmail: false,
    contributionHasStarted: false,
    blockPix: false,
    contributionCtx: 'Direct',

    goToSelectRewardTab : function(project_id){
        var url = App.webRoot + 'projeto/ajaxContribuicaoP0/' + project_id + '?freeReward=' + this.freeReward;
        // Tenho que fazer isso de forma inteligente
        $('.project-page__rewards').fadeOut(500);
        App.loadContentViaAjax(url, {}, '.project-page__info .panel-body');
    },

    goToRegisterUserTab : function(type) {
        if(type == 'pf') var url = App.webRoot + 'projeto/ajaxContribuicaoNovoCadastroPF/'
            + ProjectPage.project_id;

        if(type == 'pj') var url = App.webRoot + 'projeto/ajaxContribuicaoNovoCadastroPJ/'
            + ProjectPage.project_id;

        $('.project-page__rewards').fadeOut(500);
        App.loadContentViaAjax(url, {}, '.project-page__info .panel-body');
    },

    goToUserEditTab : function() {
        var url = App.webRoot + 'projeto/ajaxContribuicaoP2/' + ProjectPage.project_id;
        App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
        Utils.goToSidebarTop();
    },

    goConfirmation : function() {
        SidebarFormValidator.userUpdate();
    },

    goToPaymentTab : function() {
        var url = App.webRoot + 'projeto/ajaxContribuicaoP3/'
            + ProjectPage.project_id + '-' + ProjectPage.contribution_id
            + '-' + ProjectPage.benfeitoria_contribution_value
            + '-' + ProjectPage.anonColaboration + '-moip';
        App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
    },

    paymentTabStart : function (gatewayPaymentType) {
        paymentForm.init(gatewayPaymentType);
    },

    goToNext : function(url) {
        App.loadContentViaAjax(url, {}, '.panel-sidebar .panel-body');
    },

    updateUserTabEvents: function() {
        if ($('#inputPais').val()!=5) {
            $('#divInputEstado').show();
            $('#divInputCidade').show();
        }

        if ($('#inputPais').val()=='') {
            $('#divInputEstado').hide();
            $('#divInputCidade').hide();
        } else {
            if ($('#estado').val()!='') $('#divSeletorEstado').show();
            else {
                $('#divInputEstado').show();
                $('.cpf').hide();
            }
            if ($('#cidade').val()!='') $('#divSeletorCidade').show();
            else $('#divInputCidade').show();
        }

        $('#inputDataNascimento').mask('99/99/9999');
        $('#inputCEP').mask('99999-999');
        $('#inputCPF').mask('999.999.999-99');
        $('#inputCNPJ').mask('99.999.999/9999-99');

        var SPMaskBehavior = function (val) {
                return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
            },
            spOptions = {
                onKeyPress: function(val, e, field, options) {
                    field.mask(SPMaskBehavior.apply({}, arguments), options);
                }
            };

        $('#inputTelefoneResidencial').mask(SPMaskBehavior, spOptions);
    },

    multipleRewardSelector : function() {
        ProjectPage.contextAux = 0 ;
        $('[data-number-picker]').each(function (e) {
            var element = $(this);
            var max = parseInt(element.data('max')) || 10000;

            element.dpNumberPicker({
                start: 0, // Aqui estava o default que vinha do cookie -- rever
                min: 0,
                max: max,
                editable: false,
                step: 1,
                afterIncrease: function() {
                    if(max > 0) {
                        var id_reward    = element.data('id');
                        var count_reward = element.find('.dp-numberPicker-input').val();
                        ProjectPage.luggage[id_reward] = count_reward;
                        if(ProjectPage.luggage[id_reward] <= max) {
                            ++ProjectPage.contextAux;
                            $('#btn-go').prop('disabled',false);
                            $('.value-rewards').html('').html(ProjectPage.contextAux);
                        }
                    }
                },
                afterDecrease: function() {
                    if(max > 0) {
                        var id_reward    = element.data('id');
                        var count_reward = element.find('.dp-numberPicker-input').val();
                        ProjectPage.luggage[id_reward] = count_reward;
                        if(ProjectPage.luggage[id_reward] >= 0) {
                            --ProjectPage.contextAux;
                            if(ProjectPage.contextAux <= 0) {
                                $('#btn-go').prop('disabled', true);
                                ProjectPage.contextAux = 0;
                            }
                            $('.value-rewards').html('').html(ProjectPage.contextAux);
                        }
                    }
                },
            });
        });

        if(ProjectPage.multipleRewards) {
            for (var r in ProjectPage.multipleRewardsData) {

                var id = ProjectPage.multipleRewardsData[r].id;
                var times = ProjectPage.multipleRewardsData[r].quantity;

                if (times > 0) {
                    for (var x = 0; x < times; x++) {
                        $(".reward[data-id="+id+"]").find('.dp-numberPicker-add').click();
                    }
                }
            }
        } else {
            if(ProjectPage.choosenDirectReward != null) {
                $(".reward[data-id="+ProjectPage.choosenDirectReward+"]").find('.dp-numberPicker-add').click();
            }
        }
    },

    saveConfirmationContent : function(_c) {
        Utils.goToSidebarTop();
        return ProjectPage.confirmationPage = _c;
    },

    goBackConfirmation : function() {
        var url = App.webRoot + 'projeto/chooseRewards/' + ProjectPage.project_id;

        var settings = {
            method:'POST',
            data: {
                oldContribution : ProjectPage.contribution_id,
            }
        };

        Utils.goToSidebarTop();
        App.loadContentViaAjax(url, settings, '.project-page__info .panel-body');
    },

    chooseRewards : function(project_id, rewards_data){
        var url = App.webRoot + 'projeto/chooseRewards/' + project_id;

        var settings = {
            method:'POST',
            data: {
                rewards_data : rewards_data
            }
        };

        $('.project-page__info .panel-body > *').fadeOut(500);

        App.loadContentViaAjax(url, settings, '.project-page__info .panel-body', function(_c) {
            ProjectPage.saveConfirmationContent(_c);
        });
    },

    chooseFreeRewards : function(project_id) {
        var url = App.webRoot + 'projeto/chooseRewards/' + project_id;

        var settings = {
            method: 'POST',
            data: {
                isFreeReward : true,
                freeRewardValue : ProjectPage.freeRewardValue
            }
        };

        $('.project-page__info .panel-body > *').fadeOut(500);
        Utils.goToSidebarTop();
        App.loadContentViaAjax(url, settings, '.project-page__info .panel-body');
    },

    login : function(email, password, project_id, then){
        User.login(email, password , function(data){
            if(then)
                then(data);
        });
    },

    facebookLogin : function(project_id){
        Facebook.login(function(){
            //Todo : put this in a decider function (too much cp paste)
            if(ProjectPage.freeReward) {
                ProjectPage.chooseFreeRewards(ProjectPage.project_id);
            } else {
                ProjectPage.chooseRewards(ProjectPage.project_id, []);
            }
        });
    },
    recaptchaExpired() {
        document.querySelector(ProjectPage.submitSelector).disabled = true;
        ProjectPage.recaptchaResponse = null;
        ProjectPage.recaptchaData = null;
    },
    recaptchaSolved(response) {
        ProjectPage.recaptchaResponse = response;
        ProjectPage.recaptchaCheckSameSite(response, ProjectPage.recaptchaEnableSubmit);
    },
    recaptchaCheckSameSite(response, callback) {
        $.ajax({
            type: 'post',
            url: "/v2/sameSite",
            data: {
                response: response,
            },
            success: function(response) {
                const data = JSON.parse(response);
                ProjectPage.recaptchaData = data;
                if (data.success === true) {
                    if (typeof callback === "function") {
                        callback(response)
                    }
                } else {
                    alert('Atualize a página e tente novamente');
                }
            }
        });
    },
    recaptchaEnableSubmit (response) {
        if (ProjectPage.hasValidEmail === true) {
            document.querySelector(ProjectPage.submitSelector).disabled = false;
        }
    },
    newUserOverSidebar: function(type) {
        console.log('aqui');
        if (ProjectPage.recaptchaData.success === false) {
            return;
        }
        console.log('aqui 2');

        if (type === 'pf') {
            if (SidebarFormValidator.pf() && ProjectPage.hasValidEmail === true) {
                User.createFromSidebarPf();
            }
        }

        if (type === 'pj') {
            if (SidebarFormValidator.pj() && ProjectPage.hasValidEmail === true) {
                User.createFromSidebarPJ();
            }
        }
    },
    pagarViaPaypal: function(contribution_id = null) {
        if(contribution_id == null) contribution_id = ProjectPage.contribution_id;
        $('#divMensagemInfo').show();
        $('#divMensagemAviso').hide();
        $('#divMensagemErro').hide();
        document.location.href = App.webRoot+'projeto/contribuicaoPgtoPaypal/'+contribution_id;
    },
    formatMoney: function(amount, decimalCount = 2, decimal = ",", thousands = ".") {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            console.log(e)
        }
    },
    benfeitoriaContributionController: function(option) {
        var last = $('.option.active');
        var last_value = last.data('value');
        last.removeClass("active");

        var now = $(".option[data-option="+option+"]");
        now.addClass('active');

        $(".updatable-total").html(
            ProjectPage.formatMoney(parseFloat(
                $(".updatable-total")
                    .html()
                    .toString()
                    .replace(/\./g,'')
                    .replace(/,/g,'.')
                )
                - last_value
                + now.data('value'),
                2,
                ',',
                '.'
            )
        );

        $(".option-text span").addClass('hidden');
        $(".option-text > span[data-value="+now.data('value')+"]").removeClass('hidden');
    },

    activeGoalsCarrousel : function() {
        var checkitem = function(carouselId = 'default') {
            var $this;
            $this = $("#" + carouselId);
            if ($("#" + carouselId + " .carousel-inner .item:first").hasClass("active")) {
                $this.find(".prev").hide();
                $this.find(".next").show();
            } else if ($("#" + carouselId + " .carousel-inner .item:last").hasClass("active")) {
                $this.find(".next").hide();
                $this.find(".prev").show();
            } else {
                $this.find(".next").show();
                $this.find(".prev").show();
            }
        };
        $('.goals-carousel').each(function() {
            checkitem(this.id);
        });
        $('.goals-carousel').on('slid.bs.carousel', function () {
            checkitem(this.id);
        });
    },

    getBenfeitoresData: function(_project_id, _target) {
        var url = App.webRoot + 'projeto/assinantes';

        $.ajax(url).done(function(response){
            var content = $('<div/>').html(response);
            $(_target).html(content.contents());
            ProjectPage.getProjectColaborators(_project_id, "div#tab-last-contributors", ProjectPage.tabContributorsPage);
        })
    },
    /**
     * Recupera os colaboradores e popula de acordo com a paginação
     *
     * @param _project_id
     * @param _target
     */
    getProjectColaborators: function(_project_id, _target) {

        $.ajax({
            type: "POST",
            url: App.webRoot + "projeto/ajaxLastContributors",
            data: {
                project_id: _project_id,
                page: ProjectPage.tabContributorsPage,
                limit: 24
            },
            dataType: 'json',
            success: function(response) {
                var total_pages = response.pagination.total_pages;
                var contributorName, contributorPhoto, supportClass, placeholderPhoto;
                if (ProjectPage.tabContributorsPage <= total_pages) {
                    $.each(response.data.contributors, function(key, contributor) {
                        placeholderPhoto = "/v1/img/perfil/perfil" + (Math.floor(Math.random() * 3) + 1) + ".jpg";
                        if (contributor.visible === "1") {
                            contributorName = contributor.name;
                            contributorPhoto = contributor.photo;
                            supportClass = " project-tab-contributor--visible ";
                        } else {
                            contributorName = 'Anônimo';
                            contributorPhoto = placeholderPhoto;
                            supportClass = " desaturate ";
                        }
                        $(_target).append(
                            '<div class="col-md-1 col-sm-1 col-xs-1 project-page__last-contributors__item" style="padding-left:0">\n' +
                            '   <a href="#" title="' + contributorName + '">\n' +
                            '       <img\n' +
                            '           title="' + contributorName + '"\n' +
                            '           class="' + supportClass + ' assinanteAjax project-tab-contributor"\n' +
                            '           data-src="'+ contributorPhoto + '"\n' +
                            '           data-placeholder="'+ placeholderPhoto + '"\n' +
                            '           width="40px"\n' +
                            '           height="40px"\n' +
                            '       />\n' +
                            '   </a>\n' +
                            '</div>'
                        );
                    });
                    if (ProjectPage.tabContributorsPage < total_pages) {
                        ProjectPage.tabContributorsPage = ProjectPage.tabContributorsPage+1;
                    } else {
                        $('#tab-last-contributors-btn-load-more').hide();
                    }
                }
                $('img.project-tab-contributor[title!=""]').qtip({
                    style: {
                        classes: 'qtip-core'
                    }
                });
                asyncImageComponent.lazyLoadAbstract();
            },
            error: function(response) {

            }
        });
    },

    newsSave: function(title, content) {
        content = CKEDITOR.instances.editorCreateNews.getData();
        $.ajax({
            type: 'POST',
            url: App.webRoot + 'projeto/ajaxGravaNovidade',
            data: {id_project: ProjectPage.project_id, title: title, content: content, type: 'news'},
            dataType: 'json',
            cache: false,
            timeout: 8000,
            success: function (data) {
                if (data.retorno == 'ok') {
                    $('modalNovaNoticia').modal('hide');
                    // Aqui irá recarregar as novidades
                    location.reload();
                }
                else {
                    alert('Erro ao tentar gravar a novidade. Tente novamente mais tarde.');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                switch (textStatus) {
                    case 'timeout'  :
                        alert('timeout');
                        $('.error').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>');
                        break;
                    default         :
                        alert(errorThrown);
                        $('.error').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>' + errorThrown);
                        break;
                }
            }
        });
    },

    hideTabsForMobile: function() {
        Utils.hideForMobile(".nav-projetct-menu");
        Utils.hideForMobile(".panel-details");
    },
    runDetailsCKEditor: () => {

        var sMensagem = CKEDITOR.instances[sIdEditor].getData();
    },

    throttleContribution: () => {
        var remainingTime = $(".countdown").html();
        var interval = setInterval(function() {

            var timer = remainingTime.split(':');

            var minutes = parseInt(timer[0], 10);
            var seconds = parseInt(timer[1], 10);
            --seconds;
            minutes = (seconds < 0) ? --minutes : minutes;
            if (minutes < 0) {
                $(".waiting").hide();
                $(".ready").show();
                return clearInterval(interval);
            }
            seconds = (seconds < 0) ? 59 : seconds;
            seconds = (seconds < 10) ? '0' + seconds : seconds;

            $('.countdown').html(minutes + ':' + seconds);
            remainingTime = minutes + ':' + seconds;
        }, 1000);
    }
};

//Binding Events

ProjectPage.activeGoalsCarrousel();
Utils.enableHeartbeat();
Utils.responsifyVideos();

ProjectPage.project_id = $('.project.project-page').data('id');

(function(){
    let contributionFloatingCta = document.getElementById('contributionFloatingCta');

    if (contributionFloatingCta !== null) {
        const myScrollFunc = function() {
            let contributionHasStarted = ProjectPage.contributionHasStarted;
            if (contributionHasStarted !== true) {
                contributionFloatingCta.style.display = (window.scrollY >= 360) ? "block" : "none";
            }
        };

        window.addEventListener("scroll", myScrollFunc);
    }
})();

App.bindEvent('contribute','click',function(ev){
    var button = $(ev.target);
    var project_id = button.data('project_id');
    var project_type = button.data('project_type');
    ProjectPage.contributionCtx = button.data('ctx');
    $(".project-page__main").addClass('hidden-xs');
    $(".project-page__main").addClass('hidden-sm');
    ProjectPage.contributionHasStarted = true;
    ProjectPage.project_id = project_id;

    amplitude.getInstance('benfeitoria-nova').logEvent('ColaborationFlow.Start', {
        'Ctx': ProjectPage.contributionCtx,
        'ProjectType': project_type,
        'ProjectId': project_id
    });

    Utils.goToSidebarTop();
    ProjectPage.hideTabsForMobile();
    ProjectPage.goToSelectRewardTab(project_id);
    document.getElementById('contributionFloatingCta').style.display = 'none';
});

App.bindEvent('project-page-register-pf', 'click', function(ev) {
    Utils.goToSidebarTop();
    ProjectPage.goToRegisterUserTab('pf');
})

App.bindEvent('project-page-register-pf-submit', 'click', function(ev) {
    ev.preventDefault();
    ProjectPage.newUserOverSidebar('pf');
});

App.bindEvent('project-page-register-pj', 'click', function(ev) {
    Utils.goToSidebarTop();
    ProjectPage.goToRegisterUserTab('pj');
})

App.bindEvent('project-page-register-pj-submit', 'click', function(ev) {
    ev.preventDefault();
    ProjectPage.newUserOverSidebar('pj');
});

App.bindEvent('choose_reward','click',function(ev){
    var reward = $(ev.target);
    ProjectPage.choosenDirectReward = reward.data('id');
    ProjectPage.contributionCtx = "RewardPick";
    
    amplitude.getInstance('benfeitoria-nova').logEvent('ColaborationFlow.Start', {
        'Ctx': ProjectPage.contributionCtx
    });

    // Tenho que fazer isso de forma inteligente
    $('.project-page__rewards').fadeOut(500);

    var project_id = reward.parents('.project').data('id');
    ProjectPage.project_id = project_id;

    var data = [
        {
            id: reward.data('id'),
            quantity: 1
        }
    ];

    ProjectPage.contributionHasStarted = true;

    Utils.goToSidebarTop();
    ProjectPage.hideTabsForMobile();
    ProjectPage.chooseRewards(project_id, data);

    document.getElementById('contributionFloatingCta').style.display = 'none';

    return false;
});

App.bindEvent('no_reward_confirmation','change',function(ev){
    $("#no-reward-value").mask('9999999999999');
    $("#freeValor").mask('9999999999999');
    $(".project-page__no-reward__form").slideToggle(500);
    $(".project-page__yes__cupom").slideToggle(500);

    $(this).parents('.project-page__no-reward')
        .siblings('.project-page__rewards')
        .slideToggle(500);
});


App.bindEvent('has-cupom-confirmation','change',function(ev){
    $(".project-page__has-cupom__form").slideToggle(500);
    $(".project-page__no-reward").slideToggle(500);

    $(this).parents('.project-page__yes__cupom')
        .siblings('.project-page__rewards')
        .slideToggle(500);
});

App.bindEvent('reward_quantity_control', 'click', function(ev){
    var button = $(this);

    var target_input = button.siblings('input');

    if(button.data('control') == 'up')
        target_input.val(parseInt(target_input.val()) + 1);
    else
        target_input.val(parseInt(target_input.val()) - 1);

    if(target_input.val() < 0)
        target_input.val(0);
});

App.bindEvent('project_page_login', 'submit',  function(ev){
    ev.preventDefault();

    var form = $(ev.target);

    var email = $('[name=email]', form).val();
    var password = $('[name=password]', form).val();
    var project_id = form.parents('.project').data('id');

    ProjectPage.project_id = project_id;

    var submit_button = $('[type=submit]',form);

    submit_button.button('loading');

    App.buttons_to_reset.push(submit_button);

    $(".alert-login").slideUp();

    ProjectPage.login(email, password, project_id, function(data) {
        if(data.status == 'ok') {
            Utils.goToSidebarTop();
            if(ProjectPage.freeReward) {
                ProjectPage.chooseFreeRewards(ProjectPage.project_id);
            } else {
                ProjectPage.chooseRewards(ProjectPage.project_id, []);
            }
        } else {
            $(".alert-login").slideDown();
            $('html, body').animate({
                scrollTop: $(".alert-login").offset().top - 120
            }, 2000);
            App.resetButtons();
        }
    });

    return false;
});

App.bindEvent('project_page_facebook_login','submit',function(ev){

    ev.preventDefault();

    var form = $(this);

    var project_id = form.parents('.project').data('id');
    ProjectPage.project_id = project_id;

    var submit_button = $('[type=submit]',form);

    submit_button.button('loading');

    App.buttons_to_reset.push(submit_button);

    ProjectPage.facebookLogin(project_id);
});

App.bindEvent('benfeitoresTab', 'click', function(ev) {
    if( ! $(".bakers").length) {
        ProjectPage.getBenfeitoresData($('.project').data('id'), "#contributors");
    }
});

App.bindEvent('tab-last-contributors-load-more', 'click', function(ev) {
    ProjectPage.getProjectColaborators($('.project').data('id'), "#tab-last-contributors");
});

App.bindEvent('novaNoticia', 'click', function(ev) {
    ProjectPage.newsSave($('#noticia_titulo').val(), '');
})

App.bindEvent('countrySelect', 'change', function(ev) {
    Utils.countrySelectorAfterAct($('#inputPais').val());
})

App.bindEvent('citySelect', 'change', function(ev) {
    Utils.citySelectorAfterAct($('#estado').val(),$('#inputCEP').attr('data-city'));
})

let cepBuffer = null;
App.bindEvent('cepFill', 'keyup', function(ev) {
    if(cepBuffer !== $('#inputCEP').val()){
        cepBuffer = $('#inputCEP').val();
        Utils.cepFillAfterAct($('#inputCEP').val());
    }
})

App.bindEvent('verifyMail', 'change' , function(ev) {
    ProjectPage.hasValidEmail = Utils.verificaEmail(App.webRoot+'ajaxVerificaEmail', $('#inputEmail').val());
})

App.bindEvent('registerPf', 'click' , function(ev) {
    ProjectPage.newUserOverSidebar('pf');
})


App.bindEvent('registerPJ', 'click' , function(ev) {
    ProjectPage.newUserOverSidebar('pj');
})

App.bindEvent('morerewards', 'click', function(ev) {
    Utils.goToSidebarTop();
    ProjectPage.goToSelectRewardTab(ProjectPage.project_id);
})

App.bindEvent('select_benfeitoria_contribution', 'click', function(ev) {
    ProjectPage.benfeitoria_contribution = $(this).data('option');
    ProjectPage.benfeitoriaContributionController($(this).data('option'));
})

App.bindEvent('gopayment', 'click', function(ev) {
    ev.preventDefault();
    Utils.goToSidebarTop();
    ProjectPage.contribution_id = $('.js-evbind-gopayment').data('contribution');
    ProjectPage.benfeitoria_contribution_value = $(".option.active").data("value");
    ProjectPage.goToPaymentTab();
})

App.bindEvent('no_reward_go', 'submit', function(ev) {
    ev.preventDefault();
    var value = $("#no-reward-value").val();

    if ((parseInt(value) < 10) || (value == '')) {
        ev.preventDefault();
        $("#divMensagemErro").slideDown();
    } else {
        ProjectPage.freeReward = true;
        ProjectPage.freeRewardValue = value;
        ProjectPage.chooseFreeRewards(ProjectPage.project_id);
    }
})

App.bindEvent('has_cupom_go', 'submit', function(ev) {
    ev.preventDefault();
    var value = $("#cupom-value").val();
    
    var form = $(ev.target);
    var submit_button = $('[type=submit]',form);

    submit_button.button('loading');
    App.buttons_to_reset.push(submit_button);

    $.ajax({
            type: "POST",
            url: App.webRoot + "projeto/checkValidCupom",
            data: {
                cupom_id : value,
                project_id : ProjectPage.project_id
            },
            dataType: 'json',
            success: function(response) {
                if(response.status == 'not-so-good') {
                    ev.preventDefault();
                    $("#divMensagemErro").slideDown();
                    App.resetButtons();
                } else {
                     var url = App.webRoot + 'projeto/finishCupomStuff';
                     App.loadContentViaAjax(url, { method:'POST', data: { value : response.data.value, project_id : ProjectPage.project_id } }, '.project-page__info .panel-body');              
                }
            }
    })
})